import { DestinationEvent } from '@eventbrite/event-renderer';
import { sdkRequest } from '@eventbrite/http';
import { DateAggResponse } from '../../../constants/dates';
import { EventSearchBody } from '../../../constants/search';

//TODO: Update types in this file to leverage ENUMS instead of string literals (can leverage constants in code etc)

interface PaginationResponse {
    object_count: number;
    page_size: number;
    continuation: string;
}

export interface TagAggResponse {
    inflated?: {
        prefix: string;
        tag: string;
        display_name: string;
    };
    display_name: string;
    key: string;
    doc_count?: number;
}

export interface OrganizerAutocompleteAggResponse {
    inflated: string;
    display_name: string;
    key: string;
    doc_count: number;
}

export interface AggResponse<T> {
    buckets: T[];
}

export interface SearchResponse {
    articles: unknown;
    current_user_id: string;
    profile_search: unknown;
    article_search: unknown;
    profiles: unknown;
    event_search: EventSearchBody;
    events: {
        pagination: PaginationResponse;
        results: DestinationEvent[];
        aggs?: {
            dates?: AggResponse<DateAggResponse>;
            tags?: AggResponse<TagAggResponse>;
            organizertagsautocomplete_agg?: AggResponse<OrganizerAutocompleteAggResponse>;
        };
    };
}
type ExpansionBody = {
    'expand.destination_event'?: string[];
    'expand.destination_profile'?: string[];
};

const SEARCH_API_URL = '/api/v3/destination/search/';
const EXPANSIONS: ExpansionBody = {
    'expand.destination_event': [
        'primary_venue',
        'image',
        'ticket_availability',
        'saves',
        'event_sales_status',
        'primary_organizer',
        'public_collections',
    ],
    'expand.destination_profile': ['image'],
};

export const search = (
    eventSearch: EventSearchBody,
    expansions = EXPANSIONS,
): Promise<SearchResponse> => {
    return sdkRequest(SEARCH_API_URL, {
        method: 'POST',
        body: JSON.stringify({ event_search: eventSearch, ...expansions }),
    });
};
